angular.module('mobilezuz').controller('AddGiftCardCtrl', [
    '$rootScope', '$scope', '$filter', 'Config', 'Cart', 'mDesign', 'PaymentsService', 'options', 'SP_PAYMENTS',
    function ($rootScope, $scope, $filter, Config, Cart, mDesign, PaymentsService, options, SP_PAYMENTS) {
        var addGiftCardCtrl = this,
            _roundCurrencyFilter = $filter('roundCurrency');
        addGiftCardCtrl.giftCards = options.giftCards || [];
        addGiftCardCtrl.redeemedGiftCards = options.redeemedGiftCards || {};
        addGiftCardCtrl.mainPaymentMethod = options.mainPaymentMethod;
        addGiftCardCtrl.giftCardsSeeMore = false;
        addGiftCardCtrl.giftCardsData = {};
        addGiftCardCtrl.removedGiftCards = [];
        addGiftCardCtrl.giftCardsSettings = Config.retailer.settings.giftCardsSettings ? JSON.parse(Config.retailer.settings.giftCardsSettings) : {};
        addGiftCardCtrl.total = Cart.total.finalPriceWithTax + Cart.total.serviceFee.finalPriceWithTax + Cart.total.deliveryCost.finalPriceWithTax;
        addGiftCardCtrl.giftCardPopupSettings = Config.retailer.settings.checkoutDisplaySettings ? JSON.parse(Config.retailer.settings.checkoutDisplaySettings) : {};
        addGiftCardCtrl.giftCardInputRegExp = new RegExp(/^[0-9.-]*$/);
        addGiftCardCtrl.showMoreLessToggle = showMoreLessToggle;
        addGiftCardCtrl.toggleSelectedGiftCard = toggleSelectedGiftCard;
        addGiftCardCtrl.checkGiftCard = checkGiftCard;
        addGiftCardCtrl.redeemGiftCard = redeemGiftCard;
        addGiftCardCtrl.removeCard = removeCard;
        addGiftCardCtrl.isDisableRedeemBtn = isDisableRedeemBtn;
        addGiftCardCtrl.checkAmount = checkAmount;
        addGiftCardCtrl.resetCardDetails = resetCardDetails;
        addGiftCardCtrl.isGiftCardNotEligible = isGiftCardNotEligible;
        addGiftCardCtrl.next = next;
        addGiftCardCtrl.close = close;

        _init();

        function _init() {
            if($rootScope.isUsedCashbackPoints) {
                addGiftCardCtrl.total -= options.availableUserCashback;
            }

            _setGiftCardsData();
            _calculateBalanceToBePayed();
        }

        function showMoreLessToggle() {
            addGiftCardCtrl.giftCardsSeeMore = !addGiftCardCtrl.giftCardsSeeMore;
        }

        function toggleSelectedGiftCard (giftCardId) {
            addGiftCardCtrl.giftCardsSeeMore = false;
            if(addGiftCardCtrl.selectedGiftCard === giftCardId) {
                addGiftCardCtrl.selectedGiftCard = null;
            } else {
                addGiftCardCtrl.selectedGiftCard = giftCardId;
            }
        }

        function checkGiftCard (paymentMethodId) {
            addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = '';
            return PaymentsService.getGiftCardBalance(paymentMethodId ,addGiftCardCtrl.giftCardsData[paymentMethodId].number)
                .then(function (result) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].balance = result.balance;
                    addGiftCardCtrl.giftCardsData[paymentMethodId].token = result.token;
                    addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits = result.lastFourDigits;
                    addGiftCardCtrl.giftCardsData[paymentMethodId].amount = _roundCurrencyFilter(addGiftCardCtrl.giftCardsData[paymentMethodId].balance < addGiftCardCtrl.balanceToBePayed ? addGiftCardCtrl.giftCardsData[paymentMethodId].balance : addGiftCardCtrl.balanceToBePayed);
                    addGiftCardCtrl.maxAmount = addGiftCardCtrl.giftCardsData[paymentMethodId].amount;

                }).catch(function (err) {
                    addGiftCardCtrl.giftCardsData[paymentMethodId].errorMessage = 'gift_card_error_message';
                });
        }

        function redeemGiftCard (paymentMethodId) {
            if(addGiftCardCtrl.removedGiftCards[paymentMethodId]) {
                delete addGiftCardCtrl.removedGiftCards[paymentMethodId];
            }

            addGiftCardCtrl.redeemedGiftCards[paymentMethodId] = {
                methodId: paymentMethodId,
                amount: addGiftCardCtrl.giftCardsData[paymentMethodId].amount,
                cardNumber: addGiftCardCtrl.giftCardsData[paymentMethodId].number,
                token: addGiftCardCtrl.giftCardsData[paymentMethodId].token,
                lastFourDigits: addGiftCardCtrl.giftCardsData[paymentMethodId].lastFourDigits,
                paymentsNumber: 1
            }

            addGiftCardCtrl.balanceToBePayed = addGiftCardCtrl.balanceToBePayed.toFixed(2);
            addGiftCardCtrl.balanceToBePayed -= addGiftCardCtrl.giftCardsData[paymentMethodId].amount;
            addGiftCardCtrl.giftCardsData[paymentMethodId] = null;
        }

        function removeCard(paymentMethodId) {
            addGiftCardCtrl.removedGiftCards[paymentMethodId] = addGiftCardCtrl.redeemedGiftCards[paymentMethodId];
            delete addGiftCardCtrl.redeemedGiftCards[paymentMethodId];
            _calculateBalanceToBePayed();
        }

        function resetCardDetails(paymentMethodId) {
            addGiftCardCtrl.wrongAmountError = '';
            addGiftCardCtrl.giftCardsData[paymentMethodId] = {};
        }

        function checkAmount(paymentMethodId) {
            addGiftCardCtrl.wrongAmountError = '';

            if(addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.maxAmount) {
                addGiftCardCtrl.wrongAmountError = 'wrong_gift_card_amount_error';
            }
        }

        function isDisableRedeemBtn(paymentMethodId) {
            return !addGiftCardCtrl.giftCardsData[paymentMethodId].amount || addGiftCardCtrl.giftCardsData[paymentMethodId].amount < 0 ||
                !addGiftCardCtrl.balanceToBePayed || addGiftCardCtrl.giftCardsData[paymentMethodId].amount > addGiftCardCtrl.maxAmount;
        }

        function isGiftCardNotEligible(paymentMethodId) {
            return paymentMethodId === SP_PAYMENTS.PAYMENT_METHODS.IDS.TAV_PLUS && addGiftCardCtrl.mainPaymentMethod !== SP_PAYMENTS.PAYMENT_METHODS.IDS.CREDIT_CARD &&
                addGiftCardCtrl.selectedGiftCard === paymentMethodId;
        }

        function close () {
            if(addGiftCardCtrl.removedGiftCards) {
                angular.extend(addGiftCardCtrl.redeemedGiftCards, addGiftCardCtrl.removedGiftCards);
            }
            mDesign.hide();
        }

        function next () {
            mDesign.hide(addGiftCardCtrl.redeemedGiftCards);
        }

        function _setGiftCardsData() {
            angular.forEach(addGiftCardCtrl.giftCards, function (giftCard) {
                addGiftCardCtrl.giftCardsData[giftCard.paymentMethodId] = {
                    number: null,
                    balance: null
                };
            });
        }

        function _calculateBalanceToBePayed() {
            addGiftCardCtrl.balanceToBePayed = addGiftCardCtrl.total;
            var keys = Object.keys(addGiftCardCtrl.redeemedGiftCards);
            angular.forEach(keys, function (giftCardId) {
                addGiftCardCtrl.balanceToBePayed -= addGiftCardCtrl.redeemedGiftCards[giftCardId] ? addGiftCardCtrl.redeemedGiftCards[giftCardId].amount : 0;
            });
        }
    }]);
